import { NavLink, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "./SignUp.css";
import AuthSideImg from "./AuthSideImg";
import {
  IconCalendarWeek,
  IconMail,
  IconPhone,
  IconUser,
} from "@tabler/icons-react";
import { useState } from "react";
import PasswordInput from "../../components/PasswordInput";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, aspetto_logo } from "../../constant/_constant";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { validatePassword } from "../../utils/_helpers";
import { Form, Button, Row, Col, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import SuccessPopUp from "./SuccessPopUp";

const SignUp = () => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    dob: "",
    username: "",
    password: "",
    password_confirmation: "",
  });
  const [errors, setErrors] = useState({
    first_name: { message: "", rule: "" },
    last_name: { message: "", rule: "" },
    email: { message: "", rule: "" },
    phone: { message: "", rule: "" },
    dob: { message: "", rule: "" },
    username: { message: "", rule: "" },
    password: { message: "", rule: "" },
    password_confirmation: { message: "", rule: "" },
  });

  const navigate = useNavigate();
  const { data, isLoading, postData } = usePostRequest(API_ENDPOINTS.REGISTER);

  const handleChange = (e) => {
    if (e.target.name === "dob") {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.name]: moment(e.target.value).format("MM/DD/YYYY"),
      }));
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    setErrors((prevState) => ({
      ...prevState,
      [e.target.name]: { message: "", rule: "" },
    }));
  };

  const onSuccess = (response) => {
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      dob: "",
      username: "",
      password: "",
      password_confirmation: "",
    });
    setValidated(false);
    setIsSuccessModalOpen(true);
  };

  const onError = (error) => {
    if (error.errors) {
      toast.error(error?.message);
      setErrors({
        first_name: { message: "", rule: "" },
        last_name: { message: "", rule: "" },
        email: { message: "", rule: "" },
        phone: { message: "", rule: "" },
        dob: { message: "", rule: "" },
        username: { message: "", rule: "" },
        password: { message: "", rule: "" },
        password_confirmation: { message: "", rule: "" },
        ...error.errors,
      });
    }

    setValidated(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setValidated(true);

    if (form.checkValidity() === true) {
      console.log(formData);

      const payload = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        phone: formData.phone,
        dob: moment(formData.dob, "MM/DD/YYYY").format("YYYY-MM-DD"),
        username: formData.username,
        password: formData.password,
        password_confirmation: formData.password_confirmation,
      };

      postData(payload, onSuccess, onError);
    }
  };

  const { message, className, isValid } = validatePassword(
    formData.password,
    formData.password_confirmation,
  );

  return (
    <div className="row g-0 flex-fill">
      {isSuccessModalOpen && (
        <SuccessPopUp
          isOpen={isSuccessModalOpen}
          setIsOpen={setIsSuccessModalOpen}
          dataForSuccessPage={data}
          HeadingContent={"Thank You For Registration"}
        />
      )}
      <div className="col-12 col-lg-6 col-xl-4 border-top-wide border-warning d-flex flex-column justify-content-center">
        <div className="container container-tight my-5 px-lg-5">
          <div className="text-center w-50 mb-3 m-auto">
            <img src={aspetto_logo} height={80} alt="aspetto_logo" />
          </div>
          <h2 className="heading_login text-center mb-3">
            Aspetto Portal - User Registration
          </h2>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="first_name">
                  <Form.Label className="required">First Name</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Enter First Name"
                      name="first_name"
                      required
                      isInvalid={!!errors.first_name.message}
                      onChange={handleChange}
                      value={formData.first_name}
                    />
                    <InputGroup.Text>
                      <IconUser stroke={1} />
                    </InputGroup.Text>
                    <Form.Control.Feedback type="invalid">
                      {errors.first_name.message ||
                        "Please enter your first name."}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="last_name">
                  <Form.Label className="required">Last Name</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Enter Last Name"
                      name="last_name"
                      required
                      isInvalid={!!errors.last_name.message}
                      onChange={handleChange}
                      value={formData.last_name}
                    />
                    <InputGroup.Text>
                      <IconUser stroke={1} />
                    </InputGroup.Text>
                    <Form.Control.Feedback type="invalid">
                      {errors.last_name.message ||
                        "Please enter your last name."}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label className="required">Email ID</Form.Label>
              <InputGroup>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  name="email"
                  required
                  isInvalid={!!errors.email.message}
                  onChange={handleChange}
                  value={formData.email}
                />
                <InputGroup.Text>
                  <IconMail stroke={1} />
                </InputGroup.Text>
                <Form.Control.Feedback type="invalid">
                  {errors.email.message || "Please enter a valid email."}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <Form.Group className="mb-3" controlId="phone">
              <Form.Label className="required">Phone Number</Form.Label>
              <InputGroup>
                <Form.Control
                  type="number"
                  placeholder="Enter Phone Number"
                  name="phone"
                  required
                  isInvalid={!!errors.phone.message}
                  onChange={handleChange}
                  value={formData.phone}
                />
                <InputGroup.Text>
                  <IconPhone stroke={1} />
                </InputGroup.Text>
                <Form.Control.Feedback type="invalid">
                  {errors.phone.message || "Please enter a valid phone number."}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="dob">
                  <Form.Label className="required">Date Of Birth</Form.Label>
                  <InputGroup>
                    <DatePicker
                      name="dob"
                      className="form-control"
                      placeholderText="Select a date"
                      dateFormat="MM/dd/yyyy"
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown
                      showYearDropdown
                      showMonthDropdown
                      required
                      onChange={
                        (date) =>
                          handleChange({ target: { name: "dob", value: date } })

                        // moment(data?.publishedDate).format("YYYY-MM-DD")
                      }
                      // selected={formData.dob}
                      value={formData.dob}
                    />
                    <InputGroup.Text>
                      <IconCalendarWeek stroke={1} />
                    </InputGroup.Text>

                    <Form.Control.Feedback type="invalid">
                      {errors.dob.message ||
                        "Please enter a valid phone number."}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3" controlId="username">
                  <Form.Label className="required">Username</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Enter Username"
                      name="username"
                      required
                      isInvalid={!!errors.username.message}
                      onChange={handleChange}
                      value={formData.username}
                    />
                    <InputGroup.Text>
                      <IconUser stroke={1} />
                    </InputGroup.Text>
                    <Form.Control.Feedback type="invalid">
                      {errors.username.message || "Please enter username."}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <PasswordInput
                  value={formData.password}
                  onChange={handleChange}
                  name="password"
                  placeholder="******"
                  required={true}
                  errors={errors?.password?.message}
                  customHeading="Password"
                />
              </Col>
              <Col md={6}>
                <PasswordInput
                  customHeading={"Confirm Password"}
                  value={formData.password_confirmation}
                  onChange={handleChange}
                  name="password_confirmation"
                  placeholder="******"
                  required={true}
                  errors={errors?.password?.message}
                />
              </Col>
            </Row>
            <Button
              type="submit"
              className={`btn btn-theme w-100 ${
                isLoading ? "btn-loading" : ""
              }`}
              disabled={isLoading || !isValid}
            >
              Sign Up
            </Button>
          </Form>
          <div className="text-center text-secondary mt-3">
            Already a user?{" "}
            <NavLink to="/" tabIndex={-1}>
              Sign In
            </NavLink>
          </div>
        </div>
      </div>
      <AuthSideImg />
    </div>
  );
};

export default SignUp;
